
export default {
    //获取日志列表
    getBehaviorList: '/log/logBehaviorList',
    //日志导出
    getBehaviorExport: '/log/logBehaviorExport',
    //用户列表
    getUserList: '/system/sysUser/userList',
}